import { render, staticRenderFns } from "./Archive_Desktop.vue?vue&type=template&id=04b6a62b&scoped=true&"
import script from "./Archive_Desktop.vue?vue&type=script&lang=js&"
export * from "./Archive_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./Archive_Desktop.vue?vue&type=style&index=0&id=04b6a62b&prod&lang=css&"
import style1 from "./Archive_Desktop.vue?vue&type=style&index=1&id=04b6a62b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b6a62b",
  null
  
)

export default component.exports